<template>
  <div
    class="tab-pane fade"
    id="userCompensationAndBenefits"
    ref="formContainer"
  >
    <div v-if="activeTab == 'userCompensationAndBenefits'">
      <div class="card">
        <div class="card-body">
          <h3 class="card-title">Compensation & Benefits</h3>

          <form @submit.prevent="saveUserInformation">
            <div class="row">
              <div
                class="col-12 col-md-6"
                v-for="field in userInformationFields"
                :key="field.id"
              >
                <div class="input-block mb-3">
                  <label :for="field.slug" class="col-form-label">
                    {{ field.name }}
                    <span v-if="field.is_required" class="text-danger">*</span>
                  </label>

                  <!-- Text / Number / Date Inputs -->
                  <input
                    v-if="['text', 'number', 'date'].includes(field.field_type)"
                    :type="field.field_type"
                    :id="field.slug"
                    v-model="userInformationFormData[field.slug]"
                    :class="{ 'is-invalid': fieldErrors[field.slug] }"
                    class="form-control"
                  />

                  <!-- Select Input -->
                  <select
                    v-else-if="field.field_type === 'select'"
                    :id="field.slug"
                    v-model="userInformationFormData[field.slug]"
                    :class="{ 'is-invalid': fieldErrors[field.slug] }"
                    class="form-select form-select-lg"
                  >
                    <option value="">Select {{ field.name }}</option>
                    <option
                      v-for="opt in field.options"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      {{ opt.label }}
                    </option>
                  </select>

                  <!-- Radio Input -->
                  <div v-else-if="field.field_type === 'radio'">
                    <label
                      v-for="opt in field.options"
                      :key="opt.value"
                      class="inline-flex items-center mr-4"
                    >
                      <input
                        type="radio"
                        :name="field.slug"
                        :value="opt.value"
                        v-model="userInformationFormData[field.slug]"
                      />
                      <span class="ml-2">{{ opt.label }}</span>
                    </label>
                  </div>

                  <!-- Checkbox Input -->
                  <div v-else-if="field.field_type === 'checkbox'">
                    <label
                      v-for="opt in field.options"
                      :key="opt.value"
                      class="inline-flex items-center mr-4"
                    >
                      <input
                        type="checkbox"
                        :value="opt.value"
                        v-model="userInformationFormData[field.slug]"
                      />
                      <span class="ml-2">{{ opt.label }}</span>
                    </label>
                  </div>

                  <small v-if="fieldErrors[field.slug]" class="text-danger">
                    {{ fieldErrors[field.slug] }}
                  </small>
                </div>
              </div>
            </div>

            <div class="submit-section">
              <button type="submit" class="btn btn-primary submit-btn">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import { Form, Field } from "vee-validate";

export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      face_file: null,
      image_path: null,
      is_face_recognization_enabled: null,
      hasEditPermission: null,
      fieldErrors: {},
    };
  },
  watch: {
    employeeData(newVal) {
      this.image_path = newVal?.face_file
        ? process.env.VUE_APP_IMAGE_BASE_URL + newVal?.face_file
        : null;
      this.is_face_recognization_enabled = newVal?.is_face_recognization_enabled
        ? true
        : false;
    },
  },
  props: {
    employeeID: {
      type: Number,
      default: null,
      required: false,
    },
    activeTab: {
      type: String,
      default: null,
      required: false,
    },
    employeeData: {
      type: Object,
      default: null,
    },
    userInformationFormData: {
      type: [Object, Array],
      default: null,
    },
    userInformationFields: {
      type: [Object, Array],
      default: null,
    },
  },

  methods: {
    saveUserInformation() {
      this.fieldErrors = {};
      let hasError = false;

      this.userInformationFields.forEach((field) => {
        if (
          field.is_required &&
          (!this.userInformationFormData[field.slug] ||
            this.userInformationFormData[field.slug].length === 0)
        ) {
          this.fieldErrors[field.slug] = `${field.name} is required`;
          hasError = true;
        }
      });

      if (hasError) {
        notification.open({
          message: "Please fill up the mandatory fields.",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
        return;
      }

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var user_id = this?.$route?.params?.user_id || "";

      var formdata = new FormData();
      formdata.append("employee_id", user_id);

      for (let slug in this.userInformationFormData) {
        if (Array.isArray(this.userInformationFormData[slug])) {
          // for checkboxes (multiple values)
          this.userInformationFormData[slug].forEach((val) => {
            formdata.append(`${slug}[]`, val);
          });
        } else {
          // text, number, date, select, radio
          formdata.append(slug, this.userInformationFormData[slug]);
        }
      }

      axios
        .post("/userfields/save", formdata)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response?.data?.message || "Successfully Imported",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$emit("load-fields", "userCompensationAndBenefits");
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", {
        module: "face_recognization",
        action: "write",
      })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });
  },
};
</script>
<style scoped>
.col-md-6.border-right {
  border-right: 1px solid #e5dcdc;
}
.center-image-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
}

.center-image {
  width: 200px;
  height: 200px;
}
</style>
